// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__EBPPQ","mainContent":"Layout_mainContent__8yOxS","content":"Layout_content__PWopC"};